<template>
    <v-data-table
    v-bind="$attrs"
    v-on="$listeners"
    :headers="headers"
    item-key="_id"
  >
    <template v-slot:body.prepend>
      <tr class="totals-row">
        <td>
          <v-btn small icon color="white" @click="() => $emit('click:filter')">
            <v-icon small>
              mdi-filter
            </v-icon>
          </v-btn>
        </td>

        <td colspan="4" />

        <td :class="['text-right', { 'error--text': overview.totalQuantity < 0 }]">
          {{ formatNumber(overview.totalQuantity) }}
        </td>

        <td colspan="3" />

        <td :class="['text-right', { 'error--text': overview.totalValue < 0 }]">
          {{ formatMoney(overview.totalValue) }}
        </td>
      </tr>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn small icon color="primary" :disabled="readonly" @click="() => $emit('click:edit', item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>

      <v-btn small icon color="error" :disabled="readonly" @click="() => $emit('click:delete', item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>

      <v-tooltip top>
        <template v-slot:activator="tooltipProps">
          <v-btn
            small
            icon
            color="primary"
            @click="() => copyId(item._id)"

            v-bind="tooltipProps.attrs"
            v-on="tooltipProps.on"
          >
            <v-icon small>
              mdi-content-copy
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:default>
          Copiar _id
        </template>
      </v-tooltip>
    </template>

    <template v-slot:item.maturity="{ item }">
      {{ formatDate(item.maturity) }}
    </template>

    <template v-slot:item.quantity="{ item }">
      <span :class="{ 'error--text': item.quantity < 0 }">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.price="{ item }">
      {{ formatMoney(item.price) }}
    </template>

    <template v-slot:item.rate="{ item }">
      {{ formatPercentage(item.rate) }}
    </template>

    <template v-slot:item.settlementDate="{ item }">
      {{ formatDate(item.settlementDate) }}
    </template>

    <template v-slot:item.value="{ item }">
      <span :class="{ 'error--text': item.value < 0 }">
        {{ formatMoney(item.value) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import {
  formatDate,
  formatMoney,
  formatNumber,
  formatPercentage,
} from '@/utils/format-utils';

import copyToClipboard from '@/utils/copy-to-clipboard';

import { getBondsOverview } from './utils/bonds-operations-utils';

export default {
  name: 'BondsOperationsDetailsTable',

  inheritAttrs: false,

  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    headers: [
      {
        value: 'actions',
        text: 'Ações',
        sortable: false,
        groupable: false,
        width: '120px',
      },

      {
        value: 'name',
        text: 'Título',
      },

      {
        value: 'maturity',
        text: 'Vencimento',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'operation',
        text: 'Operação',
      },

      {
        value: 'quantity',
        text: 'Quantidade',
        align: 'end',
      },

      {
        value: 'price',
        text: 'PU',
        align: 'end',
      },

      {
        value: 'rate',
        text: 'Taxa',
        align: 'end',
      },

      {
        value: 'settlementDate',
        text: 'Liquidação',
      },

      {
        value: 'value',
        text: 'Valor',
        align: 'end',
      },
    ],
  }),

  computed: {
    overview: (vm) => getBondsOverview(vm.$attrs.items ?? []),
  },

  methods: {
    formatDate,
    formatMoney,
    formatNumber,
    formatPercentage,

    copyId(id) {
      try {
        copyToClipboard(id);

        this.$store.dispatch('notification', {
          text: `_id ${id} copiado com sucesso!`,
          status: true,
        });
      } catch (error) {
        this.$store.dispatch('notification', {
          text: `Não foi possível copiar o _id ${id}`,
          status: true,
          color: 'error',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.totals-row td {
  background: #18324f;
  position: sticky;
  top: 32px;

  color: #fff;
  font-weight: 500;

  z-index: 2;
}
</style>
